import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';
import type {LoadingStates} from '@Utils/loading.util';
import {publishImageDesign} from '@Components/ai-chat-window/lib/publish-design.library';
import {useAiChatActions} from '@AiChat/providers/ai-chat.context';
import {firePublishingOptionChosen} from '@Components/ai-chat-window/lib/ai-chat-callback-events.library';
import {PublishedAssetKind} from '@AiChat/callbacks/ai-chat-callbacks.types';
import {useAiChatCallbacks} from '@AiChat/callbacks/ai-chat-callbacks.context';

interface UsePublishChatModelGeneratedImage {
  publishToSocialMedia: () => Promise<void>;
  promoteAsEvent: () => Promise<void>;
  publishAsEmailCampaign: () => Promise<void>;
}

export const usePublishChatModelGeneratedImage = (chatId: string, hashedId: string): UsePublishChatModelGeneratedImage => {
  const actions = useAiChatActions();
  const callbacks = useAiChatCallbacks();

  const updateLoadingPublishingOption = (loadingOption: PublishingOption | null, loadingState: LoadingStates): void => {
    actions.updateLoadingStatesForImageActions(chatId, hashedId, {
      loadingPublishingOption: loadingOption,
      publishingLoadingState: loadingState,
    });
  };

  const publish = async (option: PublishingOption): Promise<void> => {
    firePublishingOptionChosen(callbacks, {kind: PublishedAssetKind.IMAGE, chatId, option, imageHashedId: hashedId});
    await publishImageDesign(option, hashedId, updateLoadingPublishingOption);
  };

  return {
    publishToSocialMedia: (): Promise<void> => {
      return publish(PublishingOption.PUBLISH_TO_SOCIAL_MEDIA);
    },
    promoteAsEvent: (): Promise<void> => {
      return publish(PublishingOption.PROMOTE_AS_EVENT);
    },
    publishAsEmailCampaign: (): Promise<void> => {
      return publish(PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN);
    },
  };
};
